/**
 * Home page scripts.
 *
 * @module Home
 */

import Map from '../components/map';
import Main01 from './sections/01-main';
import Main03 from './sections/03-catalog';
import '../modules/dep/jquery.dotdotdot.min'
import { currentPage } from "../modules/dev/helpers"
$(document).ready(function() {
	if (currentPage === 'product') {
		if ( $(window).width() > 1024 ) {
            $('.single-product__hero').dotdotdot({
                ellipsis: '... ',
                height: 95
            });
		}

	}

})
/** Import sections scripts */
window.onbeforeunload = function () {
	if (currentPage === 'home') {
        $('body').css({opacity: 0})
        window.scrollTo(0, 0);
	}

}
export default class Home {
	constructor() {
		Home.init();
	}
  /**
   * Initialize Main page scripts.
   *
   * @static
   */
  static init() {
  	let svgMap = new Map('#map');
  	svgMap.init();
  	
	  Main01.init();
	  if ($('#brands').length) {
		  Main03.init();
	  }
  }
}



// WEBPACK FOOTER //
// ./src/js/pages/home.js